import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Modal,
  Select,
  Input,
  Switch,
  BackTop,
} from "antd";
import { formateDate } from "../../utils/dateUtil";
import { connect } from "react-redux";
import { req_page_gqm_alumniApplyModifyList } from "../../api";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
//import { formateDate } from '../../utils/dateUtil'

import AlumniApplyModifyCheckModal from "../alumnisurvey/alumni-apply-modify-check-modal";

class AlumniApplyModifyList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "WAIT",
    loading: false,
    domnloadFile: "",
    isEditAlumniInfoModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gqm_alumniApplyModifyList(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "申請日期",
        dataIndex: "RecordCreateDateTime",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {formateDate(field)}</span>
            </div>
          );
        },
      },
      {
        title: "身份證",
        dataIndex: "TwId",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "AlumniName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "狀態",
        dataIndex: "ProcessStatus",
        width: 30,
        render: (text, record) => (
          <div className="text-center">
            <span style={{ fontSize: "1.3em" }}>
              {" "}
              {text === "WAIT" ? "未處理" : "已審查"}
            </span>
          </div>
        ),
      },
      {
        title: "",
        dataIndex: "",
        width: 20,
        render: (item) => {
          const { ProcessStatus } = item;
          return (
            <>
              <Button
                type="dashed"
                style={{ color: ProcessStatus === "WAIT" ? "Red" : "Green" }}
                onClick={() => this.handle_show_ui_modal("EDIT", item)}
              >
                <i className="fa fa-address-book"></i>{" "}
                <span style={{ marginLeft: "4px" }}>明細</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NowStatusSecondary":
        switch (param) {
          case "尚待確認":
            return "red";
          case "就業":
          case "服役":
          case "升學":
          case "留學":
            return "green";
          case "其他":
            return "purple";
          default:
            return "default";
        }
      default:
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      // const status = [...Object.values(filters).filter(Boolean)][0];
      const status = this.state.filterStatus;
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "EDIT":
        this.setState({ isEditAlumniInfoModal: true, item });
        break;
      default:
    }
  };

  handle_show_ui_surveyYear = (year, item) => {
    switch (year) {
      case 1:
        this.setState({ isShowSurveyFirstModal: true, item });
        break;
      case 3:
        this.setState({ isShowSurveyThreeModal: true, item });
        break;
      case 5:
        this.setState({ isShowSurveyFiveModal: true, item });
        break;
      default:
        break;
    }
  };

  handle_show_ui_response = (item, yearSurvey) => {
    // console.log(yearSurvey)
    this.setState({ isShowSurveyResponseModal: true });
    this.responseYearSurveyCode = yearSurvey;
    //console.log(this.responseYearSurveyCode)
  };

  handle_check_changed = () => {
    const tag = this.state.filterStatus;
    const filterStatus = tag === "WAIT" ? "ALL" : "WAIT";
    this.setState({ filterStatus }, () => {
      this.api_page_items(this.current);
    });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isEditAlumniInfoModal,
      filterStatus,
    } = this.state;
    const title = (
      <span>
        <div>
          <Switch
            checkedChildren="顯示未處理案件"
            unCheckedChildren="顯示所有案件"
            defaultChecked={filterStatus === "WAIT" ? true : false}
            onClick={this.handle_check_changed}
          />
        </div>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="TWID">身份證字號</Select.Option>
          <Select.Option value="NAME">校友姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />

        <Modal
          destroyOnClose={true}
          title="檢核個資數據"
          visible={isEditAlumniInfoModal}
          width={"80%"}
          bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
          onOk={() => {
            this.setState({ isEditAlumniInfoModal: false });
            this.api_page_items(this.current);
          }}
          onCancel={() => {
            this.setState({ isEditAlumniInfoModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AlumniApplyModifyCheckModal sourcealumni={item} />
        </Modal>

        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniApplyModifyList);
